import { useLocation } from 'react-router-dom';

import SubWorkspace from '../Components/SubWorkspace';
import './pages.css';
import Breadcrumbs, { IBreadcrumb } from '../Components/Breadcrumbs';
import { Helmet } from 'react-helmet-async';

const SubWork = () => {
  const location = useLocation();
  const parentWorkspaceName =
    localStorage.getItem('workspace') ??
    location.state?.wname ??
    localStorage.getItem('workspaceName') ??
    'SubWorkspace';

  const breadcrumbs: IBreadcrumb[] = [
    {
      name: 'Home',
      href: '/',
      className: 'breadcrumb-link',
    },
    {
      name: 'Workspace',
      href: '/',
      className: 'breadcrumb-link',
    },
    {
      name: parentWorkspaceName,
      href: ``,
      className: 'breadcrumb-current',
      isCurrent: true,
    },
  ];

  return (
    <>
      <Helmet prioritizeSeoTags defer>
        <title>{parentWorkspaceName} - Workspace | Silzila</title>
      </Helmet>
      <Breadcrumbs breadcrumbs={breadcrumbs} className="breadcrumb" />
      <SubWorkspace />
    </>
  );
};

export default SubWork;
